module.exports = __webpack_public_path__ + "f5e8a30e6618fe79723ae918c69dadfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/discover.png
// module id = 518
// module chunks = 0